import React from "react";
import WhatsAppButton from "components/WhatsAppButton";

const Help = () => {
  return <WhatsAppButton />;
};
export default Help;
